import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "src/redux/hooks";
/**
 * Custom hook to check user permissions based on the current route and permission list.
 *
 * @returns A function to check if a specific permission is allowed.
 */
export const useCheckPerm = () => {
  const { pathname } = useLocation();
  const perms = useSelector(state => state.permsSlice.perms);
  const checkPerm = useCallback(
    (perm: string) => {
      if (
        pathname.includes("exports") &&
        ["viewfiles", "downloadfiles"].includes(perm)
      ) {
        return true;
      }
      return perms.includes(perm);
    },
    [pathname, perms],
  );
  return checkPerm;
};
